var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00947 0.411987H0.740723V10.6543H8.00947V0.411987ZM5.03592 1.73358H6.68794V3.38557H5.03592V1.73358ZM2.06235 1.73358H3.71433V3.38557H2.06235V1.73358ZM2.06228 4.70714H3.71426V6.35913H2.06228V4.70714ZM3.71426 7.68074H2.06228V9.33271H3.71426V7.68074ZM6.68794 4.70714H5.03592V6.35913H6.68794V4.70714ZM5.03592 7.68074H6.68794V9.33271H5.03592V7.68074Z",
    fill: "#1EB4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBlue);
export default __webpack_public_path__ + "static/media/building-blue.94fe8a8ab9699af140ad002f1f248ad3.svg";
export { ForwardRef as ReactComponent };